export const SET_AVG_DEMAND_EVENT = 'SET_AVG_DEMAND_EVENT'
export const SET_BALANCING = 'SET_BALANCING'
export const SET_OFFSHORE_BALANCING = 'SET_OFFSHORE_BALANCING'
export const SET_QUALITY = 'SET_QUALITY'
export const SET_FUEL_CONSUMPTION = 'SET_FUEL_CONSUMPTION'